import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, iconColor }) => {
  return (
    <div className="card hover:shadow-lg">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <h3 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">{value}</h3>
          {change && (
            <div className="flex items-center gap-1">
              <Icon 
                name={changeType === 'increase' ? 'TrendingUp' : 'TrendingDown'} 
                size={16} 
                color={changeType === 'increase' ? 'var(--color-success)' : 'var(--color-error)'}
              />
              <span className={`text-sm font-medium ${changeType === 'increase' ? 'text-success' : 'text-error'}`}>
                {change}
              </span>
              <span className="text-xs text-muted-foreground ml-1">vs last week</span>
            </div>
          )}
        </div>
        <div 
          className="w-12 h-12 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon name={icon} size={24} color={iconColor} />
        </div>
      </div>
    </div>
  );
};

export default MetricCard;